/* tslint:disable:max-line-length */
import { expandCollapse } from '@fuse/animations/expand-collapse';
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    // {
    //     id   : 'example',
    //     title: 'Example',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/example'
    // },
    {
        id: 'meeting',
        title: 'Meetings',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/meeting'
    },
    {
        id: 'contacts',
        title: 'Contacts',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/contacts'
    },
    {
        id: 'admin',
        title: 'Admin',
        icon: 'heroicons_outline:chart-pie',
        link: '/admin',
        type     : 'collapsable',
        children:[
            {
                id: 'subscriptions',
                title: 'Subscriptions',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/admin/subscription',
            },
            // {
            //     id: 'customers',
            //     title: 'Customers',
            //     type: 'basic',
            //     icon: 'heroicons_outline:chart-pie',
            //     link: '/admin/subscription/customers',
            // },
            // {
            //     id: 'users',
            //     title: 'Users',
            //     type: 'basic',
            //     icon: 'heroicons_outline:users',
            //     link: '/admin/users',
            // },
        ]
    },


];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'accounts',
        title: 'Accounts',
        type: 'basic',
        icon: 'heroicons_outline:building-office-2',
        link: '/accounts'
    },
    {
        id: 'contacts',
        title: 'Contacts',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/contacts'
    },
    {
        id: 'meeting',
        title: 'Meetings',
        type: 'basic',
        icon: 'heroicons_outline:calendar',
        link: '/meetings'
    },
    {
        id: 'product',
        title: 'Products',
        type: 'basic',
        icon: 'heroicons_outline:circle-stack',
        link: '/products'
    },
    {
        id: 'admin',
        title: 'Admin',
        icon: 'heroicons_outline:lock-closed',
        link: '/admin',
        type     : 'collapsable',
        children:[
            {
                id: 'subscriptions',
                title: 'Subscriptions',
                type: 'basic',
                icon: 'heroicons_outline:cash',
                link: '/admin/subscription',
            },
        ]
    },
];

// GAP-MEETUX-CONTACTUI-015 / SPEC-008d: nav grouped under WORKSPACE / LIBRARY
// section labels (Fuse `group` type renders the group title as a section label),
// matching the canonical app-shell.js sidebar-sect-label structure.
export const isNavigation: FuseNavigationItem[] = [
    {
        id: 'workspace', title: 'Workspace', type: 'group', children: [
            { id: 'queue',    title: 'Queue',      type: 'basic', icon: 'heroicons_outline:inbox-stack',       link: '/queue',    badge: { title: '7', classes: 'px-2 bg-purple-500 text-white rounded-full' } },
            { id: 'accounts', title: 'Accounts',   type: 'basic', icon: 'heroicons_outline:building-office-2', link: '/accounts' },
            { id: 'contacts', title: 'Contacts',   type: 'basic', icon: 'heroicons_outline:user-group',        link: '/contacts' },
            { id: 'schedule', title: 'Schedule',   type: 'basic', icon: 'heroicons_outline:calendar',          link: '/schedule' },
            { id: 'sessions', title: 'My Sessions',type: 'basic', icon: 'heroicons_outline:play',              link: '/sessions' },
        ]
    },
    {
        id: 'library', title: 'Library', type: 'group', children: [
            { id: 'products', title: 'Products',   type: 'basic', icon: 'heroicons_outline:circle-stack',      link: '/products' },
        ]
    },
];

export const fsNavigation: FuseNavigationItem[] = [
    {
        id: 'workspace', title: 'Workspace', type: 'group', children: [
            { id: 'deals',    title: 'My Deals',   type: 'basic', icon: 'heroicons_outline:briefcase',         link: '/deals',    badge: { title: '6', classes: 'px-2 bg-orange-500 text-white rounded-full' } },
            { id: 'accounts', title: 'Accounts',   type: 'basic', icon: 'heroicons_outline:building-office-2', link: '/accounts' },
            { id: 'schedule', title: 'Schedule',   type: 'basic', icon: 'heroicons_outline:calendar',          link: '/schedule' },
            { id: 'contacts', title: 'Contacts',   type: 'basic', icon: 'heroicons_outline:user-group',        link: '/contacts' },
            { id: 'sessions', title: 'My Sessions',type: 'basic', icon: 'heroicons_outline:play',              link: '/sessions' },
        ]
    },
    {
        id: 'library', title: 'Library', type: 'group', children: [
            { id: 'products', title: 'Products',   type: 'basic', icon: 'heroicons_outline:circle-stack',      link: '/products' },
        ]
    },
];

export const croNavigation: FuseNavigationItem[] = [
    {
        id: 'workspace', title: 'Workspace', type: 'group', children: [
            { id: 'portfolio', title: 'Portfolio', type: 'basic', icon: 'heroicons_outline:chart-pie',         link: '/portfolio' },
            { id: 'reps',      title: 'Reps',      type: 'basic', icon: 'heroicons_outline:user-group',        link: '/reps' },
            { id: 'forecast',  title: 'Forecast',  type: 'basic', icon: 'heroicons_outline:arrow-trending-up', link: '/forecast' },
            { id: 'coaching',  title: 'Coaching',  type: 'basic', icon: 'heroicons_outline:megaphone',         link: '/coaching' },
        ]
    },
    {
        id: 'library', title: 'Library', type: 'group', children: [
            { id: 'products',  title: 'Products',  type: 'basic', icon: 'heroicons_outline:circle-stack',      link: '/products' },
        ]
    },
];

export const adminNavigation: FuseNavigationItem[] = [
    {
        id: 'workspace', title: 'Workspace', type: 'group', children: [
            // SESSION-meet-ux-004h fix: exactMatch keeps Overview from also lighting up
            // for any /admin/* descendant (Users / Teams / Billing / Data / Settings),
            // which previously caused two simultaneously-active rows.
            { id: 'overview', title: 'Overview', type: 'basic', icon: 'heroicons_outline:home',         link: '/admin', exactMatch: true },
            // GAP-MEETUX-NAV-USERS-BADGE (2026-06-18): hardcoded badge "40" was
            // stale + misleading (real workspace might have 2 or 200). The Users
            // page surfaces the live "N of M seats" count in its header; the
            // sidebar entry doesn't need to duplicate it. Remove the badge until
            // the seat-summary stream is wired into the nav config (deferred).
            { id: 'users',    title: 'Users',    type: 'basic', icon: 'heroicons_outline:user-group',   link: '/admin/users' },
            { id: 'teams',    title: 'Teams',    type: 'basic', icon: 'heroicons_outline:shield-check',  link: '/teams' },
            { id: 'billing',  title: 'Billing',  type: 'basic', icon: 'heroicons_outline:credit-card',  link: '/admin/billing' },
            { id: 'data',     title: 'Data',     type: 'basic', icon: 'heroicons_outline:circle-stack',  link: '/admin/data' },
            { id: 'settings', title: 'Settings', type: 'basic', icon: 'heroicons_outline:cog-6-tooth',  link: '/admin/settings' },
        ]
    },
    {
        id: 'library', title: 'Library', type: 'group', children: [
            { id: 'products', title: 'Products', type: 'basic', icon: 'heroicons_outline:circle-stack',  link: '/products' },
        ]
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example'
    }
];
